module.exports = __webpack_public_path__ + "static/media/blue_image.588f32e7.webp";